import { graphql } from "react-relay";

export const slackChannelPickerFragments = {
  org: graphql`
    fragment SlackChannelPicker_org on Org @argumentDefinitions(teamId: { type: "String!" }) {
      publicChannelsForSlackForTeam(teamId: $teamId) {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on SlackChannelList {
          list {
            channelId
            name
          }
        }
      }
    }
  `,
};
